var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20013_9165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.57054 4.71299L5.28378 15.2696C5.36215 15.7529 5.60615 16.1921 5.97233 16.509C6.3385 16.8259 6.80306 16.9999 7.28324 17H9.99784M15.4286 4.71299L13.7162 15.2696C13.6379 15.7529 13.3938 16.1921 13.0277 16.509C12.6615 16.8259 12.1969 16.9999 11.7168 17H9.00216M7.89622 8.7684V12.9446M11.1038 8.7684V12.9446M2 4.71299H17M11.7516 4.71299V3.24069C11.7516 2.91164 11.6235 2.59607 11.3954 2.36339C11.1673 2.13072 10.858 2 10.5354 2H8.46459C8.14203 2 7.83268 2.13072 7.6046 2.36339C7.37652 2.59607 7.24838 2.91164 7.24838 3.24069V4.71299H11.7516Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20013_9165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListDelete);
export default __webpack_public_path__ + "static/media/list_delete.8b6e2bd5038b984a2a957ca64a0c2aa2.svg";
export { ForwardRef as ReactComponent };